const routes = [
    {
        path: "/mentora/course-approval-review",
        component: () => import("../pages/Index"),
        meta: {
            isAuthenticated: true,
            permission: "studentsession_index",
        }
    }
];

export default routes;
